import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { DeviceType } from '@/api/client'

export type DiffView = 'unified' | 'side-by-side'

interface SettingsState {
  defaultDevice: DeviceType

  /** Phase 6: master toggle for the AI suggestion pipeline. */
  aiEnabled: boolean
  /** Phase 6: model name sent on each audit. Falls back to BFF default when empty. */
  aiModel: string

  /** Layout for AI-suggestion patches. Default `unified` matches the original UI. */
  diffView: DiffView

  setDefaultDevice: (device: DeviceType) => void
  setAiEnabled: (enabled: boolean) => void
  setAiModel: (model: string) => void
  setDiffView: (view: DiffView) => void
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    set => ({
      defaultDevice: 'DESKTOP',
      aiEnabled: true,
      aiModel: '',
      diffView: 'unified',

      setDefaultDevice: device => set({ defaultDevice: device }),
      setAiEnabled: enabled => set({ aiEnabled: enabled }),
      setAiModel: model => set({ aiModel: model }),
      setDiffView: view => set({ diffView: view }),
    }),
    { name: 'lens-settings' },
  ),
)
